module.exports = __webpack_public_path__ + "media/images/autopilot/people-7ff97a4adf0957e2ec94f07d2c98b556.svg";